<template>
  <div>
    <div class="modal-backdrop fade show"></div>

    <div class="modal fade show modal-dialog-centered">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ element.name }}</h5>

            <div class="position-absolute pt-2" style="top:0;left:0;width:100%;">
              <div class="d-flex flex-row justify-content-center">
                <div v-for="slide in slides"
                     :key="`pager-${slide.id}`"
                     @click="currentSlide = slide.id"
                     :class="`cursor-pointer mx-1 border border-${currentSlide === slide.id ? 'primary' : 'white'}`"
                     style="width:60px;height:auto;">
                  <img class="d-block w-100" :src="slide.image" alt="">
                </div>
              </div>
            </div>

            <button
              @click="$emit('close')"
              type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center" v-if="slide">
            <transition name="fade" mode="out-in">
              <img :src="slide.image" class="img-fluid" alt="" height="100%">
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthContent',

  props: ['slides', 'element'],

  data() {
    return {
      currentSlide: null,
    };
  },

  created() {
    this.currentSlide = this.slides.length > 0 ? this.slides[0].id : null;
  },

  computed: {
    slide() {
      return this.slides.find(s => s.id === this.currentSlide);
    },
  },

  methods: {},
};
</script>
